import { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import { Autocomplete, Tooltip } from "@mui/material";
import React from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Controller, useForm } from "react-hook-form";
// import 'cleave.js/dist/addons/cleave-phone.us'
import InputMask from "react-input-mask";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { yupResolver } from "@hookform/resolvers/yup";
import Swal from "sweetalert2";

import * as Yup from "yup";
import Modal from "@mui/material/Modal";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
// import { useRouter, withRouter } from 'next/router'
import Avatar from "@mui/material/Avatar";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import AddIcon from "@mui/icons-material/Add";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { useAlert } from "react-alert";
import Moment from "moment";
import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import Documents from "./Documents";
import OSAPAGE from "./Osapage";
import VOBPAGE1 from "./Vobpage1";
import Prior_auth from "./Prior_auth";
import PatientRegistration from "./PatientRegistration";
import Demographics from "./Demographics";
import "./Button.css";
//import { confirmAlert } from 'react-confirm-alert'
import Headroom from "react-headroom";
import Card from "@mui/material/Card";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CircularProgress from "@mui/material/CircularProgress";
import DialogTitle from "@mui/material/DialogTitle";
import Letter from "./Letter";
import Checkbox from "@mui/material/Checkbox";
import {
  ArrowDropDown,
  ArrowDropDownCircle,
  FamilyRestroomRounded,
  ImportExport,
} from "@mui/icons-material";
import Popover from "@mui/material/Popover";
import Disclaimer from "./Disclaimer";
import { values } from "lodash";
import DentistUse from "./DentistUse";
// import { co } from '@fullcalendar/core/internal-common'

// const validationSchema = Yup.object({
//   patientName: Yup.string().required("Please Select Patient Name"),
// });
const AuthorizationRegistration = (props) => {
  // document.title = "Authorization Registration | LuxBilling";
  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  const alert = useAlert();
  const dashID = props.dashID;
  const [columnID, setcolumnID] = useState(
    props.callingFrom == "dashboard" ? props.dashID : props.columnID
  );
  const patientName =
    props.callingFrom == "dashboard" ? props.Dashboard : props.patientName;
  const [historyid, sethistoryid] = useState(props.columnID);
  const [questionnaireid, setquestionnaireid] = useState(props.columnID);
  const [processnoteid, setprocessnoteid] = useState(props.columnID);
  const [authRequestid, setauthRequestid] = useState(props.columnID);
  const [approveid, setapproveid] = useState(props.columnID);
  const [history, sethistory] = useState(false);
  const [dentalExam, setdentalExam] = useState(false);

  const [additionalinfo, setAdditionalinfo] = useState(false);

  const [idcard, setIdcard] = useState(false);
  const [sleeptest, setsleeptest] = useState(false);
  const [authRequest, setauthRequest] = useState(false);
  const [processnote, setprocessnote] = useState(false);
  const [newdisclaimer, setnewdisclaimer] = useState(false);
  const [newdentist, setnewdentist] = useState(false);

  const [lomn, setLomn] = useState(false);
  const [questionnaire, setquestionnaire] = useState(false);
  const [approve, setapprove] = useState(false);
  const [type, settype] = useState("");
  const pName = props.pName;
  const fields = [
    "id",
    "dos",
    "pos",
    "patientId",
    "patientInfo",
    "healthHistory",
    "questionnaire",
    "progressNotes",
    "authRequest",
    "sleepStudy",
    "approved",
    "patientName",
    "lomn",
    "sleepTest",
    "disclaimer",
    "idCard",
    "additionalInfo",
    "inactive",
    "practiceId",
    "approval",
    "submission",
    "dentalExam",
    "approve",
    "dateSubmission",
    "createdBy",
    "createdDate",
    "updatedDate",
    "updatedBy",
  ];
  const defValues = {
    id: 0,
    dos: "",
    patientId: "",
    pos: "",
    patientInfo: "",
    practiceId: "",
    healthHistory: "",
    dentalExam: "",
    questionnaire: "",
    progressNotes: "",
    authRequest: null,
    sleepStudy: null,
    approved: null,
    lomn: "",
    sleepTest: "",
    patientName: "",
    disclaimer: "",
    idCard: "",
    additionalInfo: "",
    patientName: patientName,
    inactive: false,
    submission: "",
    approval: "",
    dateSubmission: "",
    createdDate: "",
    createdBy: "",
    updatedBy: "",
    updatedDate: "",
  };
  const navigate = useNavigate();

  const [filteredOptions, setFilteredOptions] = useState([]);
  //   const [columnID, setColumnID] = React.useState("");
  const [refresh, setRefresh] = useState(false);
  const [patientData, setPatientData] = React.useState([]);
  const [patient, setPatient] = React.useState(false);
  const [patientSelected, setPatientSelected] = React.useState(false);
  const [patientID, setPatientID] = React.useState(props.patientId);
  const [disable, setdisable] = React.useState(true);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [patientNamee, setPatientNamee] = useState(patientName);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState("");
  const [selectedValueId, setselectedValueId] = useState(false);
  const [patientInfo, setpatientInfo] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const PatientStyle = {
    cursor: "pointer",
    hover: {
      background: "#3b3b3b !important",
      color: "rgba(5, 152, 236, 0.637) !important",
    },
    color: "green",
    selection: {
      background: "#D7624E",
      color: "white",
    },
  };

  const {
    register,
    control,
    handleSubmit,
    setValue,
    reset,
    form,
    watch,
    getValues,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onChange",
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    // resolver: yupResolver(validationSchema),
    defaultValues: defValues,
  });

  // API's Calling
  useEffect(() => {
    if (patientSelected) {
      setselectedValueId(true);
    } else {
      setselectedValueId(false); // Set to false when patientSelected is false
    }
  }, [patientName]);
  const FormCall = props.FormCall;
  const onChangeHandle = async (value) => {
    // this default api does not support searching but if you use google maps or some other use the value and post to get back you reslut and then set it using setOptions
    setIsLoading(true);
    const sendData = {
      id: 0,
      lastName: value,
      firstName: "",
      ssn: "",
      status: "",
      cellPhone: "",
      address: "",
      dob: "",
      patientId: "",
    };
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/Patients/searchPatient`,
        sendData,
        { headers },
        setPatientSelected(false)
      )
      .then((response) => {
        setPatientData(response);
        // setResId(response.id)
        setPatient(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    if (props.patientId > 0 || props.AutpattientID > 0) {
      setdisable(false);
    }
  }, []);
  useEffect(() => {
    if (columnID > 0) {
      axios
        .get(
          `${process.env.REACT_APP_API_URL}/AutherizationRequest/AuthoorizationById?Id=${columnID}`,
          { headers }
        )
        .then((response) => {
          fields.forEach((field) => {
            setValue(field, response[field]);
          });
          setPatientID(response.patientId);
          setauthRequest(response.authRequest);
          setquestionnaire(response.questionnaire);
          setapprove(response.approved);
          sethistory(response.healthHistory);
          // sethistory(response.dentalExam)
          // setselectedValueId(response.patientInfo)
          setIdcard(response.idCard);
          setAdditionalinfo(response.additionalInfo);
          setsleeptest(response.sleepTest);
          setprocessnote(response.progressNotes);
          setnewdisclaimer(response.disclaimer);
          setnewdentist(response.dentalExam);
          setLomn(response.lomn);
          setdisable(false);
        })

        .catch((error) => {
          console.error("There was an error!", error);
        });
    }
    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, [columnID]);
  const [PatientNameError, setPatientNameError] = React.useState(false);
  const [FirstClick, setFirstClick] = React.useState(false);
  const AuthPracticeId = props.AuthPracticeId
  const PracticeId = localStorage.getItem("default_paractice")
  const onSubmit = (data) => {
    // setSubmitting(true);
    setdisable(false);
    const postData = data;
    if (authRequest == true) {
      postData.submission = true;
      postData.approval = true;
    }
    postData.authRequest = data.authRequest === true ? true : null;
    postData.approved = data.approved === true ? true : null;
    postData.cptCode = props.Charge1;
    if (columnID <= 0) {
      if (FormCall == "demographic") {
        setPatientNameError(false);
      } else if (!patientSelected) {
        setPatientNameError(true);
        return;
      }
    }
    setFirstClick(true);

    postData.patientId = patientID;
    postData.patientInfo = selectedValueId;
    postData.practiceId = AuthPracticeId ? AuthPracticeId : PracticeId ;
    axios
      .post(
        `${process.env.REACT_APP_API_URL}/AutherizationRequest/AddAuthorization?patientId=${patientID}`,
        postData,
        { headers }
      )

      .then((response) => {
  if (response.id) {
    setFirstClick(false);
    setdisable(true);

    Swal.fire({
      icon: "success",
      title: "Record saved successfully",
      timer: 2000,
      showConfirmButton: false,
      willOpen: () => {
        const swalContainer = document.querySelector(".swal2-container");
        if (swalContainer) {
          swalContainer.style.zIndex = 1800;

          const swalPopup = swalContainer.querySelector(".swal2-popup");
          if (swalPopup) {
            swalPopup.style.zIndex = 1801;
          }
        }
      },
      willClose: () => {
        setdisable(false);

        if (autoClosePage == false) {
          setdisable(true);
          props.CloseModal();
        }

        return null;
      },
    });
  } else if (props.callingFrom == "Apporved") {
    props.CloseModal();
  } else if (props.callingFrom == "dashboard") {
    props.CloseModal();
  }
})
.catch((error) => {
  setdisable(true);
  setFirstClick(false);

  Swal.fire({
    icon: "error",
    title: `Error ${error.message}`,
    timer: 2500,
    showConfirmButton: false,
    willOpen: () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = 1800;

        const swalPopup = swalContainer.querySelector(".swal2-popup");
        if (swalPopup) {
          swalPopup.style.zIndex = 1801;
        }
      }
    },
  });
});
  };
  // Styling
  const handleOptionChange = (event, value) => {
    setSelectedPatient(value);
    setPatientID(value.id);
  };
  const handleInputChange = (event, newValue) => {
    const trimmedValue = newValue.trim();
    if (trimmedValue.length > 0) {
      onChangeHandle(trimmedValue);
    }
  };

  const [openDocument, setOpenDocument] = React.useState(false);
  const handleCloseDocument = () => {
    setOpenDocument(false);
  };
  const handleOpen = () => {
    setautoClosePage(true);
    setOpenDocument(true);
  };
  const handleClose = () => {
    setautoClosePage(false);
    handleSubmit(onSubmit)();
    setOpenDocument(false);
  };

  const [open1, setOpen1] = React.useState(false);
  const handleCloseOSA = () => {
    setOpen1(false);
  };
  const handleOpen1 = () => {
    setautoClosePage(true);
    setOpen1(true);
  };
  const handleClose1 = () => {
    setautoClosePage(false);
    handleSubmit(onSubmit)();
    setOpen1(false);
  };
  const [autoClosePage, setautoClosePage] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const handleOpen2 = () => {
    setautoClosePage(true);
    setOpen2(true);
  };
  const handleClose22 = () => {
    setautoClosePage(false);
    setOpen2(false);
  };
  const handleClose2 = () => {
    setautoClosePage(false);
    handleSubmit(onSubmit)();
    setOpen2(false);
  };

  const [open3, setOpen3] = React.useState(false);
  const handleCloseVOB = () => {
    setOpen3(false);
    setautoClosePage(false);

  };

  const handleOpen3 = () => {
    // setautoClosePage(true);
    setOpen3(true);
  };
  const handleClose3 = () => {
    handleSubmit(onSubmit)();
    setautoClosePage(false)
    setOpen3(false);
    navigate("/dashboard");
  };
  const [open4, setOpen4] = React.useState(false);
  const handleOpen4 = () => setOpen4(true);
  const handleClose4 = () => setOpen4(false);
  const [openpatientreg, setOpenpatientreg] = React.useState(false);
  const handleOpenpatientreg = () => setOpenpatientreg(true);
  const handleClosepatientreg = () => setOpenpatientreg(false);
  const [openpatientdem, setOpenpatientdem] = React.useState(false);
  const handleOpenpatientdem = () => setOpenpatientdem(true);
  const handleClosepatientdem = () => setOpenpatientdem(false);
  const [disclaimer, setDisclaimer] = React.useState(false);
  const opendisclaimer = () => {
    setautoClosePage(true);
    setDisclaimer(true);
  };
  const closedisclaimer = () => {
    setautoClosePage(false);
    handleSubmit(onSubmit)();
    setDisclaimer(false);
  };
  const closedisclaimer1 = () => {
    setDisclaimer(false);
  };

  const [dentist, setDentist] = React.useState(false);
  const opendentist = () => {
    setautoClosePage(true);
    setDentist(true);
  };
  const closedentist1 = () => {
    setautoClosePage(false);
    setDentist(false);
  };
  const closedentist = () => {
    setautoClosePage(false);
    handleSubmit(onSubmit)();
    setDentist(false);
  };

  // const checkstyle = {
  //   position: "absolute",
  //   top: "50%",
  //   left: "50%",
  //   transform: "translate(-50%, -50%)",
  //   width: 700,
  //   height: "auto",
  //   bgcolor: "background.paper",
  //   border: "2px solid #377562",
  //   boxShadow: 24,
  // };
  const checkstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: "90%", // Mobile
      sm: "80%", // Tablet
      md: "700px", // Laptop/Desktop
    },
    height: {
      xs: "auto", // Mobile - height adjust ho
      sm: "auto", // Tablet - auto height
      md: "auto", // Laptop/Desktop fixed height
    },
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    p: {
      xs: 2, // padding for mobile
      sm: 2, // tablet
      md: 2, // desktop
    },
  };

  const checkstyle1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 1000,
    height: 500,
    bgcolor: "background.paper",
    border: "2px solid #356F60",
    boxShadow: 24,
    // overflow: "auto",
    // overflow: "auto",
    /* Other styles */
    scrollbarWidth: "thin", // For Firefox
    scrollbarColor: "#356F60 transparent", // thumb color and track color
    "&::-webkit-scrollbar": {
      width: 8 /* Width of vertical scrollbar */,
      height: 8 /* Height of horizontal scrollbar */,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#356F60" /* Color of the thumb */,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent" /* Color of the track */,
    },
    /* Adjust the width for the horizontal scrollbar */
    "&::-webkit-scrollbar-thumb:horizontal": {
      width: 4 /* Width of horizontal scrollbar */,
    },
    // zIndex: "10",
  };
  const checkstyle11 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "90%", sm: "80%", md: "100%", lg: "60%", xl: "50%" }, // ✅ Responsive width
    maxWidth: "800px", // limit so it won’t grow too much on big screens
    height: { xs: "60vh", sm: "65vh", md: "70vh", lg: "75vh", xl: "80vh" }, // ✅ Responsive height
    bgcolor: "background.paper",
    border: "2px solid #377562",
    boxShadow: 24,
    p: { xs: 2, sm: 3, md: 4 }, // ✅ Responsive padding
    overflowY: "auto", // scroll if content overflows
    borderRadius: 2, // smooth corners
  };

  const styleDetails = {
    width: "90%",
    height: "95%",
    bgcolor: "#F0FFFF",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 30,
    right: 0,
    margin: "auto",
    marginTop: "10px",
    paddingBottom: "10px",
    padding: "20px",
    overflow: "auto",
  };
  const styleDetailspatient = {
    width: "90%",
    // height: '70%',
    height: 600,
    bgcolor: "white",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    margin: "auto",
    marginTop: "10px",
    paddingBottom: "10px",
    padding: "20px",
    overflow: "auto",
    scrollbarWidth: "thin", // For Firefox
    scrollbarColor: "#356F60 transparent", // thumb color and track color
    "&::-webkit-scrollbar": {
      width: 8 /* Width of vertical scrollbar */,
      height: 8 /* Height of horizontal scrollbar */,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#356F60" /* Color of the thumb */,
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent" /* Color of the track */,
    },
    /* Adjust the width for the horizontal scrollbar */
    "&::-webkit-scrollbar-thumb:horizontal": {
      width: 4 /* Width of horizontal scrollbar */,
    },
    // zIndex: "10",
  };
  ////Question
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClosepopOver = () => {
    setAnchorEl(null);
  };
  /////Lomn
  const [anchorEl1, setAnchorEl1] = useState(null);
  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClosepopOver1 = () => {
    setAnchorEl1(null);
  };
  /////Aut Req
  const [anchorEl2, setAnchorEl2] = useState(null);
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClosepopOver2 = () => {
    setAnchorEl2(null);
  };
  //// sleep study
  const [anchorEl3, setAnchorEl3] = useState(null);
  const handleClick3 = (event) => {
    setAnchorEl3(event.currentTarget);
  };
  const handleClosepopOver3 = () => {
    setAnchorEl3(null);
  };

  /////Apporoved
  const [anchorEl4, setAnchorEl4] = useState(null);
  const handleClick4 = (event) => {
    setAnchorEl4(event.currentTarget);
  };
  const handleClosepopOver4 = () => {
    setAnchorEl4(null);
  };
  /////Sleeptest
  const [anchorEl5, setAnchorEl5] = useState(null);
  const handleClick5 = (event) => {
    setAnchorEl5(event.currentTarget);
  };
  const handleClosepopOver5 = () => {
    setAnchorEl5(null);
  };
  // sleep study 
    const [anchorSleepStudy, setanchorSleepStudy] = useState(null);
  const handleClickSleepStudy = (event) => {
    setanchorSleepStudy(event.currentTarget);
  };
  const handleCloseSleepStudy = () => {
    setanchorSleepStudy(null);
  };
  /////process note
  const [anchorEl6, setAnchorEl6] = useState(null);
  const handleClick6 = (event) => {
    setAnchorEl6(event.currentTarget);
  };
  const handleClosepopOver6 = () => {
    setAnchorEl6(null);
  };
  ///
  const [anchorEl7, setAnchorEl7] = useState(null);
  const handleClick7 = (event) => {
    setAnchorEl7(event.currentTarget);
  };
  const handleClosepopOver7 = () => {
    setAnchorEl7(null);
  };
  //idcard
  const [anchorEl8, setAnchorEl8] = useState(null);
  const handleClick8 = (event) => {
    setAnchorEl8(event.currentTarget);
  };
  const handleClosepopOver8 = () => {
    setAnchorEl8(null);
  };
  //additionalinfo
  const [anchorEl9, setAnchorEl9] = useState(null);
  const handleClick9 = (event) => {
    setAnchorEl9(event.currentTarget);
  };
  const handleClosepopOver9 = () => {
    setAnchorEl9(null);
  };

  //dentist
  const [anchorEl10, setAnchorEl10] = useState(null);
  const handleClick10 = (event) => {
    setAnchorEl10(event.currentTarget);
  };
  const handleClosepopOver10 = () => {
    setAnchorEl10(null);
  };
  ////Aut Question
  const openpop = Boolean(anchorEl);
  const idpop = openpop ? "simple-popover" : undefined;
  ////Aut Lomn
  const openpop1 = Boolean(anchorEl1);
  const idpop1 = openpop1 ? "simple-popover" : undefined;
  ////Aut Req
  const openpop2 = Boolean(anchorEl2);
  const idpop2 = openpop2 ? "simple-popover" : undefined;
  ////STUdy Sleep
  const openpop3 = Boolean(anchorEl3);
  const idpop3 = openpop3 ? "simple-popover" : undefined;
  ////Apporved
  const openpop4 = Boolean(anchorEl4);
  const idpop4 = openpop4 ? "simple-popover" : undefined;
  ////sleeptest
  const openpop5 = Boolean(anchorEl5);
  const idpop5 = openpop5 ? "simple-popover" : undefined;
  //sleep Study 
    const openSleepStudy = Boolean(anchorSleepStudy);
  const idpopSleepStudy = openSleepStudy ? "simple-popover" : undefined;
  ////process note
  const openpop6 = Boolean(anchorEl6);
  const idpop6 = openpop6 ? "simple-popover" : undefined;

  const openpop7 = Boolean(anchorEl7);
  const idpop7 = openpop7 ? "simple-popover" : undefined;
  //idcard
  const openpop8 = Boolean(anchorEl8);
  const idpop8 = openpop8 ? "simple-popover" : undefined;

  //additionalinfo
  const openpop9 = Boolean(anchorEl9);
  const idpop9 = openpop9 ? "simple-popover" : undefined;

  //dentist
  const openpop10 = Boolean(anchorEl10);
  const idpop10 = openpop10 ? "simple-popover" : undefined;

  function handleChange() {}
  return (
    <>
      <Container>
        <Modal
          open={openpatientreg}
          onClose={handleClosepatientreg}
           sx={{ zIndex: 1520 }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleDetailspatient}>
            <Grid container columnSpacing={1}>
              <Grid item xs={6} style={{ fontWeight: 500 }}>
                <Typography style={{ fontWeight: "bold", color: "black" }}>
                  Patient Registration
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ fontWeight: 500 }}>
                <Button
                  onClick={handleClosepatientreg}
                  disabled={submitting}
                  style={{
                    marginTop: "0px",
                    marginBottom: "10px",
                    float: "right",
                    marginLeft: "10px",
                    width: "90px",
                    height: "35px",
                    // backgroundColor: '#A574FD',
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  <CancelOutlinedIcon
                    fontSize="medium"
                    style={{ color: "red", paddingRight: "5px" }}
                  ></CancelOutlinedIcon>
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ fontWeight: 500, marginTop: "-90px" }}
              >
                {/* yaha columnID pass ki patientID ki jga */}

                <PatientRegistration
                  callingFrom={"Authorization"}
                  pid={patientID}
                  handleClosepatientreg={handleClosepatientreg}
                ></PatientRegistration>
              </Grid>
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={openpatientdem}
          onClose={handleClosepatientdem}
            sx={{ zIndex: 1520 }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={styleDetails}>
            <Grid container columnSpacing={1}>
              <Grid item xs={6} style={{ fontWeight: 500 }}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    marginBottom: "10px",
                  }}
                >
                  Demographics
                </Typography>
              </Grid>
              <Grid item xs={6} style={{ fontWeight: 500 }}>
                <Button
                  onClick={handleClosepatientdem}
                  disabled={submitting}
                  style={{
                    marginTop: "0px",
                    marginBottom: "10px",
                    float: "right",
                    marginLeft: "10px",
                    width: "90px",
                    height: "35px",
                    // backgroundColor: '#A574FD',
                    color: "white",
                    fontSize: "14px",
                  }}
                >
                  <CancelOutlinedIcon
                    fontSize="medium"
                    style={{ color: "red", paddingRight: "5px" }}
                  ></CancelOutlinedIcon>
                </Button>
              </Grid>
              <Demographics
                callingFrom={"Patient"}
                handleClosepatientdem={handleClosepatientdem}
              ></Demographics>
            </Grid>
          </Box>
        </Modal>

        <Modal
          id="hello-world"
          open={openDocument}
            sx={{ zIndex: 1520 }}
          onClose={handleCloseDocument}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          visible={true}
          title={"Title"}
          footer={"Footer"}
        >
          <Box sx={checkstyle}>
            <Grid container spacing={1}>
              <Grid item xs={11} style={{ fontWeight: 500, marginTop: "10px" }}>
                <Typography
                  style={{
                    fontWeight: "bold",
                    marginLeft: "5px",
                    fontSize: "18px",
                    color: "white",
                    backgroundColor: "#377562",
                  }}
                >
                  Add patient document
                </Typography>
              </Grid>
              <Grid item xs={1}>
                <Button
                  onClick={handleCloseDocument}
                  variant="gradient"
                  // disabled={submitting}
                  style={{
                    marginTop: "10px",
                    float: "right",
                    marginBottom: "5px",
                    // width: "80px",
                    height: "35px",
                    backgroundColor: "#fff",
                    color: "black",
                    fontSize: "14px",
                    cursor: "pointer",
                  }}

                  // startIcon={<img src={SaveIcon} style={{marginTop:'-3px',marginRight:'-6px',}}/>}
                >
                  <CancelOutlinedIcon
                    fontSize="medium"
                    style={{
                      color: "red",

                      paddingBottom: "2px",
                    }}
                  ></CancelOutlinedIcon>
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={12} style={{margin:'4px' , padding:'4'}}>
              <Documents
                callingFrom={"Patient"}
                patientID={patientID}
                updateHealthHistory={(
                  id,
                  authId,
                  referringPhysiciansId,
                  createdBy,
                  createdDate
                ) => {
                  console.log("setting", id);
                  setValue("createdBy", createdBy);
                  setValue("createdDate", createdDate);
                  props.setAuthId(authId);

                  console.log("tesssst222");
                  if (type == "healthHistory") {
                    setValue("healthHistory", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  } else if (type == "questionnaire") {
                    setValue("questionnaire", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  } else if (type == "lomn") {
                    setValue("lomn", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  } else if (type == "authRequest") {
                    setValue("authRequest", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  } else if (type == "progressNotes") {
                    setValue("progressNotes", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  } else if (type == "sleepTest") {
                    setValue("sleepTest", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  } else if (type == "sleepStudy") {
                    setValue("sleepStudy", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  }
                  
                  else if (type == "disclaimer") {
                    setValue("disclaimer", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  } else if (type == "idCard") {
                    setValue("idCard", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  } else if (type == "additionalInfo") {
                    setValue("additionalInfo", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  } else if (type == "dentist") {
                    setValue("dentist", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                  }
                }}
                columnID={columnID}
                type={type}
                handleClose222={handleClose}
                AutpattientID={
                  props.callingFrom === "dashboard"
                    ? props.AutpattientID
                    : patientID
                }
                patientName={
                  props.callingFrom === "dashboard"
                    ? props.Dashboard
                    : patientNamee
                }
              ></Documents>
            </Grid>
          </Box>
        </Modal>

        <Modal
          id="hello-world"
          open={open2}
            sx={{ zIndex: 1520 }}
          onClose={handleClose22}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          visible={true}
          title={"Title"}
          footer={"Footer"}
        >
          <Box sx={checkstyle1}>
            <Headroom>
              <Grid
                container
                style={{ backgroundColor: "#356F60", position: "sticky" }}
              >
                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "3rem",
                    }}
                  >
                    <DialogTitle
                      style={{
                        flex: 1,
                        textAlign: "center",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          textAlign: "center",
                          color: "#fff",
                          textDecoration: "underline",
                          fontSize: "2rem",
                        }}
                      >
                        LETTER OF MEDICAL NECESSITY{" "}
                      </h1>
                    </DialogTitle>
                    <CancelOutlinedIcon
                      onClick={handleClose22}
                      fontSize="large"
                      color="red"
                      style={{
                        color: "red",
                        paddingRight: "5px",
                        cursor: "pointer",
                        // marginLeft: 'auto',
                        // marginRight: '1.5rem'
                      }}
                    ></CancelOutlinedIcon>
                  </div>
                </Grid>
              </Grid>
            </Headroom>

            <Grid item xs={12}>
              <Card
                bordered={false}
                style={{
                  overflow: "auto",
                  /* Other styles */
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "#356F60 transparent", // thumb color and track color
                  "&::-webkit-scrollbar": {
                    width: 8 /* Width of vertical scrollbar */,
                    height: 8 /* Height of horizontal scrollbar */,
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#356F60" /* Color of the thumb */,
                    borderRadius: 10,
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "transparent" /* Color of the track */,
                  },
                  /* Adjust the width for the horizontal scrollbar */
                  "&::-webkit-scrollbar-thumb:horizontal": {
                    width: 4 /* Width of horizontal scrollbar */,
                  },
                  // zIndex: "10",
                  height: "70vh",
                }}
              >
                <Letter
                  callingFrom={"Patient"}
                  columnID={columnID}
                  AutpattientID={
                    props.callingFrom === "dashboard"
                      ? props.AutpattientID
                      : patientID
                  }
                  patientName={
                    props.callingFrom === "dashboard"
                      ? props.Dashboard
                      : patientNamee
                  }
                  handleClose2={handleClose2}
                  updateHealthHistory={(id, authId) => {
                    // setautoClosePage(true)
                    console.log("setting", id);
                    setValue("LOMN", true);
                    setcolumnID(authId);
                    // setquestionnaireid(authId)
                  }}
                ></Letter>
              </Card>
              <ToastContainer
                position="bottom-center"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </Grid>
          </Box>
        </Modal>
        <Modal
          open={open1}
          onClose={handleCloseOSA}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          visible={true}
            sx={{ zIndex: 1520 }}
          title={"Title"}
          footer={"Footer"}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={10}
            lg={8}
            xl={6}
            sx={{
              margin: "0 auto", // center on large screens
              mt: 2,
              px: { xs: 1, sm: 2, md: 3 }, // responsive padding
              maxWidth: "1320px", // ✅ prevent overflow on big screens
            }}
          >
            <Headroom>
              <Grid
                container
                style={{ backgroundColor: "#356F60", position: "sticky" }}
              >
                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "3rem",
                    }}
                  >
                    <DialogTitle
                      style={{
                        flex: 1,
                        textAlign: "center",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          textAlign: "center",
                          color: "#fff",
                          textDecoration: "underline",
                          fontSize: "clamp(1.2rem, 2vw, 2rem)", // responsive font-size
                          wordBreak: "break-word", // prevent overflow on small screens
                          margin: 0,
                        }}
                      >
                        Snoring and obstructive sleep apnea (OSA) Screener
                      </h1>
                    </DialogTitle>
                    <CancelOutlinedIcon
                      onClick={handleCloseOSA}
                      fontSize="large"
                      color="red"
                      style={{
                        color: "red",
                        paddingRight: "5px",
                        cursor: "pointer",
                        // marginLeft: 'auto',
                        // marginRight: '1.5rem'
                      }}
                    ></CancelOutlinedIcon>
                  </div>
                </Grid>
              </Grid>
            </Headroom>

            <Grid item xs={12}>
              <Card
                bordered={false}
                style={{
                  overflow: "auto",
                  /* Other styles */
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "#356F60 transparent", // thumb color and track color
                  "&::-webkit-scrollbar": {
                    width: 8 /* Width of vertical scrollbar */,
                    height: 8 /* Height of horizontal scrollbar */,
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#356F60" /* Color of the thumb */,
                    borderRadius: 10,
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "transparent" /* Color of the track */,
                  },
                  /* Adjust the width for the horizontal scrollbar */
                  "&::-webkit-scrollbar-thumb:horizontal": {
                    width: 4 /* Width of horizontal scrollbar */,
                  },
                  // zIndex: "10",
                  height: "70vh",
                }}
              >
                <OSAPAGE
                  callingFrom={"Patient"}
                  columnID={columnID}
                  AutpattientID={
                    props.callingFrom === "dashboard"
                      ? props.AutpattientID
                      : patientID
                  }
                  patientName={
                    props.callingFrom === "dashboard"
                      ? props.Dashboard
                      : patientNamee
                  }
                  handleClose1={handleClose1}
                  updateHealthHistory={(id, authId, createdBy, createdDate) => {
                    setautoClosePage(false);
                    console.log("setting", id);
                    setValue("questionnaire", true);
                    setcolumnID(authId);
                    setValue("createdBy", createdBy);
                    setValue("createdDate", createdDate);
                    setValue("id", authId);
                    // setquestionnaireid(authId)
                  }}
                ></OSAPAGE>
              </Card>
              <ToastContainer
                position="bottom-center"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </Grid>
          </Grid>
        </Modal>
        <Modal
          open={open3}
          onClose={handleCloseVOB}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          visible={true}
          title={"Title"}
          footer={"Footer"}
          // sx={{ zIndex: patientNamee && patientNamee > 0 ? 1650 : 1600 }}
          sx={{ zIndex: FormCall == "demographic" ? 1750 : 1600 }}
        >
          <Box sx={checkstyle1}>
            <Headroom>
              <Grid
                container
                style={{ backgroundColor: "#356F60", position: "sticky" }}
              >
                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "3rem",
                    }}
                  >
                    <DialogTitle
                      style={{
                        flex: 1,
                        textAlign: "center",
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: "bold",
                          textAlign: "center",
                          color: "#fff",
                          fontSize: "2rem",
                        }}
                      >
                        VOB/ Prior-auth Request
                      </h1>
                    </DialogTitle>
                    <CancelOutlinedIcon
                      onClick={handleCloseVOB}
                      fontSize="large"
                      color="red"
                      style={{
                        color: "red",
                        paddingRight: "5px",
                        cursor: "pointer",
                        // marginLeft: 'auto',
                        marginRight: "1.5rem",
                      }}
                    ></CancelOutlinedIcon>
                  </div>
                </Grid>
              </Grid>
            </Headroom>

            <Grid item xs={12}>
              <Card
                bordered={false}
                style={{
                  overflow: "auto",
                  /* Other styles */
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "#356F60 transparent", // thumb color and track color
                  "&::-webkit-scrollbar": {
                    width: 8 /* Width of vertical scrollbar */,
                    height: 8 /* Height of horizontal scrollbar */,
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#356F60" /* Color of the thumb */,
                    borderRadius: 10,
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "transparent" /* Color of the track */,
                  },
                  /* Adjust the width for the horizontal scrollbar */
                  "&::-webkit-scrollbar-thumb:horizontal": {
                    width: 4 /* Width of horizontal scrollbar */,
                  },
                  // zIndex: "10",
                  height: "70vh",
                }}
              >
                <VOBPAGE1
                  callingFrom={"Patient"}
                  columnID={columnID}
                        setResetTab={props.setResetTab}
                   ResetTab={props.ResetTab}
                  AutpattientID={
                    props.callingFrom === "dashboard"
                      ? props.AutpattientID
                      : patientID
                  }
                  patientName={
                    props.callingFrom === "dashboard"
                      ? props.Dashboard
                      : patientNamee
                  }
                  handleClose3={handleClose3}
                  updateHealthHistory={(
                    id,
                    authId,
                    patientName,
                    createdBy,
                    createdDate
                  ) => {
                    // setautoClosePage(false)
                    console.log("setting", id);
                    setValue("authRequest", true);
                    setValue("createdBy", createdBy);
                    setValue("createdDate", createdDate);
                    setValue("dateSubmission", Moment().format("YYYY-MM-DD"));
                    setcolumnID(authId);
                    setValue("id", authId);
                      setautoClosePage(false);

                    // setauthRequestid(authId)
                  }}
                ></VOBPAGE1>
              </Card>
              <ToastContainer
                position="bottom-center"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </Grid>
          </Box>
        </Modal>
        <Modal
          open={open4}
          onClose={handleClose4}
            sx={{ zIndex: 1520 }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          visible={true}
          title={"Title"}
          footer={"Footer"}
        >
          <Box sx={checkstyle1}>
            {/* <Headroom>
              <Grid
                  container
                  style={{ backgroundColor: '#356F60', position: 'sticky' }}
                >
                  <Grid item xs={12}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        height: '3rem'
                      }}
                    >
                      <DialogTitle
                        style={{
                          flex: 1,
                          textAlign: 'center',
                        }}
                      >
                        <h1
                          style={{
                            fontWeight: 'bold',
                            textAlign: 'center',
                            color: '#fff',
                            textDecoration: 'underline',
                            fontSize:'2rem'

                          }}
                        >
                        Prior-auth & VOB

                        </h1>
                      </DialogTitle>
                      <CancelOutlinedIcon
                        onClick={handleClose4}
                        fontSize="large"
                        color="red"
                        style={{
                          color: 'red',
                          paddingRight: '5px',
                          cursor: 'pointer',
                          // marginLeft: 'auto',
                          // marginRight: '1.5rem'
                        }}
                      ></CancelOutlinedIcon>
                    </div>
                  </Grid>
                </Grid>
              </Headroom> */}

            <Grid item xs={12}>
              <Card
                bordered={false}
                style={{
                  overflow: "auto",
                  /* Other styles */
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "#356F60 transparent", // thumb color and track color
                  "&::-webkit-scrollbar": {
                    width: 8 /* Width of vertical scrollbar */,
                    height: 8 /* Height of horizontal scrollbar */,
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#356F60" /* Color of the thumb */,
                    borderRadius: 10,
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "transparent" /* Color of the track */,
                  },
                  /* Adjust the width for the horizontal scrollbar */
                  "&::-webkit-scrollbar-thumb:horizontal": {
                    width: 4 /* Width of horizontal scrollbar */,
                  },
                  // zIndex: "10",
                  height: "80vh",
                }}
              >
                <Prior_auth
                  patientNamee={patientNamee}
                  patientID={patientID}
                  searchTex={patientName}
                  callingFrom={"Patient"}
                  columnID={columnID}
                  handleClose4={handleClose4}
                  AutpattientID={
                    props.callingFrom === "dashboard"
                      ? props.AutpattientID
                      : patientID
                  }
                  patientName={
                    props.callingFrom === "dashboard"
                      ? props.Dashboard
                      : patientNamee
                  }
                  updateHealthHistory={(id, authId) => {
                    // setautoClosePage(false)
                    console.log("setting", id);
                    setValue("approved", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                    // setapproveid(authId)
                  }}
                  style={{ height: "40vh" }}
                ></Prior_auth>
              </Card>
              <ToastContainer
                position="bottom-center"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </Grid>
          </Box>
        </Modal>

        <Modal
          open={disclaimer}
          onClose={closedisclaimer1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          visible={true}
          title={"Title"}
            sx={{ zIndex: 1520 }}
          footer={"Footer"}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={10}
            lg={8}
            xl={6}
            sx={{
              margin: "0 auto", // center on large screens
              mt: 2, // top margin (responsive spacing)
              px: { xs: 1, sm: 2, md: 3 }, // horizontal padding adjust

              // ✅ Responsive + Fixed Size
              width: { xs: "100%", sm: "100%", md: 1000 },
              height: { xs: "auto", sm: "auto", md: 500 },
              maxWidth: "1000px",
              maxHeight: "500px",
            }}
          >
            {/* <Headroom>
              <Grid
                container
                style={{ backgroundColor: '#356F60', position: 'sticky' }}
              >
                <Grid item xs={12}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      height: '3rem'
                    }}
                  >
                    <DialogTitle
                      style={{
                        flex: 1,
                        textAlign: 'center',
                      }}
                    >
                      <h1
                        style={{
                          fontWeight: 'bold',
                          textAlign: 'center',
                          color: '#fff',
                          textDecoration: 'underline',
                          fontSize:'2rem'

                        }}
                      >
                       Patient Responsibility Disclaimer

                      </h1>
                    </DialogTitle>
                    <CancelOutlinedIcon
                      onClick={closedisclaimer1}
                      fontSize="large"
                      color="red"
                      style={{
                        color: 'red',
                        paddingRight: '5px',
                        cursor: 'pointer',
                        // marginLeft: 'auto',
                        // marginRight: '1.5rem'
                      }}
                    ></CancelOutlinedIcon>
                  </div>
                </Grid>
              </Grid>
            </Headroom>  */}

            <Grid item xs={12}>
              <Card
                bordered={false}
                style={{
                  overflow: "auto",
                  /* Other styles */
                  scrollbarWidth: "thin", // For Firefox
                  scrollbarColor: "#356F60 transparent", // thumb color and track color
                  "&::-webkit-scrollbar": {
                    width: 8 /* Width of vertical scrollbar */,
                    height: 8 /* Height of horizontal scrollbar */,
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#356F60" /* Color of the thumb */,
                    borderRadius: 10,
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "transparent" /* Color of the track */,
                  },
                  /* Adjust the width for the horizontal scrollbar */
                  "&::-webkit-scrollbar-thumb:horizontal": {
                    width: 4 /* Width of horizontal scrollbar */,
                  },
                  // zIndex: "10",
                  height: "80vh",
                }}
              >
                <Disclaimer
                  callingFrom={"Patient"}
                  columnID={columnID}
                  AutpattientID={
                    props.callingFrom === "dashboard"
                      ? props.AutpattientID
                      : patientID
                  }
                  patientName={
                    props.callingFrom === "dashboard"
                      ? props.Dashboard
                      : patientNamee
                  }
                  closedisclaimer={closedisclaimer1}
                  updateHealthHistory={(id, authId) => {
                    // setautoClosePage(false)
                    console.log("setting", id);
                    setValue("Disclaimer", true);
                    setcolumnID(authId);
                    setValue("id", authId);
                    // setquestionnaireid(authId)
                  }}
                  style={{ height: "40vh" }}
                />
              </Card>
              <ToastContainer
                position="bottom-center"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </Grid>
          </Grid>
        </Modal>

        <Modal
          open={dentist}
          onClose={closedentist1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          visible={true}
            sx={{ zIndex: 1520 }}
          title={"Title"}
          footer={"Footer"}
        >
          {/* <Box sx={checkstyle1}> */}
          <Grid
            item
            xs={12}
            sm={12}
            md={10}
            lg={8}
            xl={6}
            sx={{
              margin: "0 auto", // center on large screens
              mt: 2, // top margin (responsive spacing)
              px: { xs: 1, sm: 2, md: 3 }, // horizontal padding adjust

              // ✅ Responsive + Fixed Size
              width: { xs: "100%", sm: "100%", md: 1320 },
              height: { xs: "auto", sm: "auto", md: 500 },
              maxWidth: "1320px",
              maxHeight: "500px",
            }}
          >
            <Headroom>
              <Grid
                container
                style={{ backgroundColor: "#356F60", position: "sticky" }}
              >
                <Grid item xs={12}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: "3rem",
                    }}
                  >
                    <DialogTitle
                      style={{
                        flex: 1,
                        textAlign: "center",
                      }}
                    >
                      <Typography
                        style={{
                          fontWeight: "bold",
                          textAlign: "center",
                          color: "#fff",
                          textDecoration: "underline",
                          fontSize: "2rem",
                        }}
                      >
                        DENTIST USE ONLY - Oral examination
                      </Typography>
                    </DialogTitle>
                    <CancelOutlinedIcon
                      onClick={closedentist1}
                      fontSize="large"
                      color="red"
                      style={{
                        color: "red",
                        paddingRight: "5px",
                        cursor: "pointer",
                        // marginLeft: 'auto',
                        // marginRight: '1.5rem'
                      }}
                    ></CancelOutlinedIcon>
                  </div>
                </Grid>
              </Grid>
            </Headroom>

            <Grid item xs={12}>
              <Card
                bordered={false}
                style={{ overflow: "auto", height: "80vh" }}
              >
                <DentistUse
                  callingFrom={"Patient"}
                  columnID={columnID}
                  AutpattientID={
                    props.callingFrom === "dashboard"
                      ? props.AutpattientID
                      : patientID
                  }
                  patientName={
                    props.callingFrom === "dashboard"
                      ? props.Dashboard
                      : patientNamee
                  }
                  closedentist={closedentist}
                  updateHealthHistory={(id, authId, createdBy, createdDate) => {
                    // setautoClosePage(false)
                    console.log("setting", id);
                    setValue("dentalExam", true);
                    setValue("createdBy", createdBy);
                    setValue("createdDate", createdDate);
                    setcolumnID(authId);
                    setValue("id", authId);
                    // setquestionnaireid(authId)
                  }}
                  style={{ height: "40vh" }}
                />
              </Card>
              <ToastContainer
                position="bottom-center"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </Grid>
          </Grid>
        </Modal>

        <Grid container columnSpacing={1}>
          <Grid item xs={12}></Grid>

          <Grid container spacing={2} marginBottom={10}>
            <Grid item xs={1.5} style={{ marginTop: "10px" }}>
              <Typography
                style={{
                  fontWeight: "bold",
                  color: "black",
                  alignItems: "left",
                }}
              >
                Patient
              </Typography>
            </Grid>

            <Grid item xs={4} style={{ marginLeft: "-15px", marginTop: "5px" }}>
              <ClickAwayListener onClickAway={() => setPatient(false)}>
                <TextField
                  autoComplete="off"
                  // isClearable
                  {...register("patientName")}
                  size="small"
                  fullWidth
                  placeholder="Search Current Patient Here..."
                  InputProps={{
                    readOnly: FormCall === "demographic" || columnID > 0,
                  }}
                  onKeyUp={(ev) => {
                    console.log("ee:", ev.target.value);
                    // dont fire API if the user delete or not entered anything
                    if (
                      ev.target.value !== null &&
                      ev.target.value !== "" &&
                      ev.target.value.length > 0
                    ) {
                      onChangeHandle(ev.target.value);
                      setSearchText(ev.target.value);
                    } else {
                      setPatientData([]);
                      setselectedValueId(false);
                      setPatientSelected(false);
                      setPatient(false);
                      setSearchText("");
                      setdisable(false);
                    }
                  }}
                  // error={errors.patientName}
                  // helperText={errors.patientName ? errors.patientName.message : ''}
                />
              </ClickAwayListener>
              {isLoading && (
                <CircularProgress
                  size={20}
                  style={{ marginLeft: "-40px", marginTop: "10px" }}
                />
              )}
              {patient ? (
                <div
                  className="col-xs-6"
                  style={{
                    padding: "14px 16px",
                    fontSize: "0.875rem",
                    color: "#67748e",
                    borderRadius: "5px",
                    background: "white",
                    textAlign: "justify",
                    textJustify: "inter-word",
                    position: "absolute",
                    zIndex: "99",
                    width: "26%",
                    border: "1px solid #6cb5f9",
                  }}
                >
                  {patient ? (
                    patientData.length > 0 ? (
                      patientData.map((s, index) => {
                        var pat = `${patientData[index].lastName}, ${patientData[index].firstName}`;

                        const searchTextLower = searchText.toLowerCase();
                        const fullNameLower = pat.toLowerCase();
                        const i = fullNameLower.indexOf(searchTextLower);

                        if (i === -1) {
                          return null;
                        }

                        const p1 = pat.substring(0, i);
                        const p = pat.substring(i, i + searchText.length);
                        const p2 = pat.substring(i + searchText.length);

                        return (
                          <>
                            <p
                              style={PatientStyle}
                              onClick={(ev) => {
                                const selectedValue = `${patientData[index].lastName}, ${patientData[index].firstName}`;
                                console.log("Selected Value:", selectedValue);
                                setselectedValueId(true);
                                // setSelectedPatient(selectedValue)
                                setValue(
                                  "patientName",
                                  `${patientData[index].lastName}, ${patientData[index].firstName}`
                                );
                                setValue("patientId", patientData[index].id);
                                setPatientID(patientData[index].id);
                                setdisable(false);
                                setPatientData([]);
                                setPatientSelected(true);
                                setPatient(false);
                                setPatientNameError(false);
                                setPatientNamee(
                                  `${patientData[index].lastName}, ${patientData[index].firstName}`
                                );
                              }}
                              onBlur={(ev) => {
                                setPatientData([]);
                                setPatient(false);
                              }}
                              onChange={(ev) => {
                                setPatientData([]);
                                setPatientSelected(false);
                                setPatient(false);
                                setPatientNamee("");
                                setdisable(true);
                              }}
                            >
                              <span>{p1}</span>
                              <span style={{ backgroundColor: "yellow" }}>
                                {p}
                              </span>
                              <span>{p2}</span>
                            </p>
                          </>
                        );
                      })
                    ) : (
                      <Typography>No Record found</Typography>
                    )
                  ) : null}
                </div>
              ) : (
                ""
              )}
              {PatientNameError && (
                <p style={{ color: "red" }}>Please Select Patient</p>
              )}
            </Grid>

          <Grid item xs={2} style={{ marginTop: "10px", display: "flex", alignItems: "center" }}>
              {patientID > 0 ? (
                <Tooltip title="View Patient Chart">
                  <Button
                    size="small"
                     variant="contained"
                    disabled={disable == true ? true : false}
                     startIcon={
                        <RemoveRedEyeIcon style={{ color: disable ? "#ccc" : "#fff" }} />
                      }
                   sx={{
                      minWidth: "170px",
                      height: "36px",
                      backgroundColor: disable ? "#e0e0e0" : "#356F60",
                      color: disable ? "#9e9e9e" : "#fff",
                      textTransform: "none",
                      borderRadius: "8px",
                      padding: "0 12px",
                      boxShadow: "none",
                      fontSize: "13px",
                      "&:hover": {
                        backgroundColor: disable ? "#e0e0e0" : "#2f5f52",
                      },
                    }}
                    onClick={handleOpenpatientreg}
                  >
                    View Patient Chart
                  </Button>
                </Tooltip>
              ) : (
                <>
                  <Tooltip title="Add New">
                    <Button
                        variant="contained"
                      startIcon={<AddIcon style={{ color: "#fff" }} />}
                      size="small"
                      sx={{
                        minWidth: "170px",
                        height: "36px",
                        backgroundColor: "#E87426",
                        color: "#fff",
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "0 12px",
                        boxShadow: "none",
                        fontSize: "13px",
                        "&:hover": {
                          backgroundColor: "#cf651f",
                        },
                      }}
                      onClick={handleOpenpatientdem}
                    >
                      Add New Patient
                    </Button>
                  </Tooltip>
                </>
              )}
            </Grid>
            {/* <Grid item xs={3} style={{ marginTop: '13px',marginLeft:'30px' }}>
              {patientID > 0 ? (
                 <Typography style={{ fontWeight: "bold", color: "black" }}>
                 View
               </Typography>
              ) : (
                <>
                   <Typography style={{ fontWeight: "bold", color: "black", marginLeft:'0.7rem' }}>
                 Add New
               </Typography>
                </>
              )}
            </Grid> */}
            <Grid item xs={4}></Grid>
            <Grid item xs={1.5}></Grid>
            <Grid item xs={10.5}>
              {/* {disable == true ? (<>
                <Typography style={{ color: "red" }}>
                  Please Select Patient Name
                </Typography>
              </>) : ('')} */}
            </Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={10.5}>
              <Grid container columnSpacing={1}>
                <input
                  name="patientInfo"
                  size="small"
                  disabled={disable == true ? true : false}
                  type="checkbox"
                  {...register("patientInfo")}
                  checked={selectedValueId}
                  onChange={(e) => {
                    setValue("patientInfo", e.target.checked);
                    setselectedValueId("patientInfo", e.target.checked);
                  }}
                  id="patientInfo"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    marginTop: "-10px",
                    transform: "scale(1.2)", // <<< This makes it bigger
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                    marginLeft: "18px",
                  }}
                />
                {/* <input
  name="patientInfo"
  size="small"
  disabled={disable === true ? true : false}
  type="checkbox"
  {...register("patientInfo")}
  checked={selectedValueId ? true : false}
  id="patientInfo"
  style={{
    marginLeft: "10px",
    marginRight: "10px",
    marginTop: "-10px",
  }}
/> */}

                <label
                  for="patientInfo"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    whiteSpace: "normal", // allow wrapping
                    wordBreak: "break-word",
                    flex: 1,
                    marginLeft: "10px", // take up remaining space
                  }}
                >
                  Patient Info
                </label>

                {/* <Typography style={{ fontWeight: "bold", color: "black" }}>
                  Patient Info
                </Typography> */}
              </Grid>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={8.5}>
              <Grid
                container
                alignItems="center"
                sx={{
                  display: "flex",
                  flexWrap: "nowrap", // keep everything in a row
                }}
              >
                <input
                  name="idCard"
                  size="small"
                  type="checkbox"
                  disabled={disable}
                  {...register("idCard")}
                  onChange={(e) => {
                    setValue("idCard", e.target.checked);
                    setIdcard("idCard", e.target.checked);
                  }}
                  id="idCard"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    marginTop: "-10px",
                    transform: "scale(1.2)", // make checkbox bigger
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                  }}
                />

                {/* Required star */}
                <label
                  htmlFor="idCard"
                  style={{
                    fontWeight: "bold",
                    color: "red",
                    fontSize: "15px",
                    marginRight: "3px",
                  }}
                >
                  *
                </label>

                {/* Main label text */}
                <label
                  htmlFor="idCard"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    whiteSpace: "normal", // allow wrapping
                    wordBreak: "break-word",
                    flex: 1, // take up remaining space
                  }}
                >
                  Patient Medical ID card (front & back)
                </label>
              </Grid>
            </Grid>

            <Grid item xs={3} style={{ marginTop: "-5px" }}>
              <Grid style={{ marginLeft: "1rem" }}>
                <ArrowDropDown
                  variant="outlined"
                  onClick={handleClick8}
                  aria-describedby={idpop8}
                  sx={{
                    cursor: "pointer",
                    fontSize: 42, // bigger size (default is 24)
                    color: "black", // darker
                    fontWeight: "bold",
                  }}
                ></ArrowDropDown>
                <Popover
                  id={idpop8}
                  open={openpop8}
                  anchorEl={anchorEl8}
                  onClose={handleClosepopOver8}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                    sx={{
                  zIndex: 1515,
                }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "0.5rem",
                      background: "#356f60",
                    }}
                  >
                    {idcard == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={(e) => {
                            settype("idCard");
                            handleOpen();
                          }}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Yours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={(e) => {
                              settype("idCard");
                              handleOpen();
                            }}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              {" "}
                              Upload Yours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Popover>
              </Grid>
            </Grid>

            <Grid item xs={0.5}></Grid>
            <Grid item xs={8.5}>
              <Grid
                container
                alignItems="center"
                sx={{
                  display: "flex",
                  flexWrap: "nowrap", // checkbox and label stay side by side
                }}
              >
                <input
                  name="questionnaire"
                  type="checkbox"
                  disabled={disable}
                  {...register("questionnaire")}
                  onChange={(e) => {
                    setValue("questionnaire", e.target.checked);
                    setquestionnaire("questionnaire", e.target.checked);
                  }}
                  id="questionnaire"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    marginTop: "-10px",
                    transform: "scale(1.2)",
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                  }}
                />

                <label
                  htmlFor="questionnaire"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    whiteSpace: "normal", // allows wrapping
                    wordBreak: "break-word", // breaks long words if needed
                    flex: 1, // take remaining space
                  }}
                >
                  <i
                    style={{
                      fontWeight: "bold",
                      color: "red",
                      fontSize: "15px",
                    }}
                  >
                    {" "}
                    *{" "}
                  </i>
                  The patient questionnaire/ screener must be completed in its
                  entirety
                </label>
              </Grid>
            </Grid>
            <Grid item xs={3} style={{ marginTop: "-5px" }}>
              {/*              
              {questionnaire == true ? (
                  <Tooltip title="View">
                <Button
                  style={{
                    backgroundColor: disable ? 'gery' : '',
                    color: 'white',

                  }}
                  size='small'
                  disabled={disable == true ? true : false}
                  onClick={handleOpen1}>
                  <RemoveRedEyeIcon
                    fontSize="medium"
                    style={{ color: "#356F60", }}
                  ></RemoveRedEyeIcon>

                </Button>
                </Tooltip>
              ) : (
                <>
                <Tooltip title="Add New">
                  <Button
                    style={{
                      backgroundColor: disable ? 'gery' : '#E87426',
                      color: 'white',

                    }}
                    size='small'
                    disabled={disable == true ? true : false}
                    onClick={handleOpen1}>
                    <AddIcon
                      fontSize="medium"
                      style={{ color: "#356F60", paddingRight: "5px" }}
                    ></AddIcon>

                  </Button>
                  </Tooltip>

                </>
              )} */}
              <Grid style={{ marginLeft: "1rem" }}>
                <ArrowDropDown
                  variant="outlined"
                  onClick={handleClick}
                  aria-describedby={idpop}
                  sx={{
                    cursor: "pointer",
                    fontSize: 42, // bigger size (default is 24)
                    color: "black", // darker
                    fontWeight: "bold",
                  }}
                ></ArrowDropDown>
                <Popover
                  id={idpop}
                  open={openpop}
                  anchorEl={anchorEl}
                  onClose={handleClosepopOver}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                    sx={{
                  zIndex: 1515,
                }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "0.5rem",
                      background: "#356f60",
                    }}
                  >
                    {questionnaire == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={handleOpen1}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            Use Ours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={handleOpen1}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              Use Ours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                    {questionnaire == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={(e) => {
                            settype("questionnaire");
                            handleOpen();
                          }}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Yours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={(e) => {
                              settype("questionnaire");
                              handleOpen();
                            }}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              {" "}
                              Upload Yours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Popover>
              </Grid>
            </Grid>

            <Grid item xs={0.5}></Grid>
            <Grid item xs={8.5}>
              <Grid
                container
                columnSpacing={1}
                sx={{
                  display: "flex",
                  flexWrap: "nowrap", // keep everything in a row
                }}
              >
                <input
                  name="dentalExam"
                  size="small"
                  type="checkbox"
                  disabled={disable === true}
                  {...register("dentalExam")}
                  id="dentalExam"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    marginTop: "-10px",
                    transform: "scale(1.2)", // make checkbox bigger
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                    marginLeft: "18px",
                  }}
                />

                <label
                  htmlFor="dentalExam"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    whiteSpace: "normal", // allow wrapping
                    wordBreak: "break-word",
                    flex: 1,
                    marginLeft: "10px", // take up remaining space
                  }}
                >
                  Dental exam questionnaire
                </label>
              </Grid>
            </Grid>

            <Grid item xs={3} style={{ marginTop: "-5px" }}>
              <Grid style={{ marginLeft: "1rem" }}>
                <ArrowDropDown
                  variant="outlined"
                  onClick={handleClick10}
                  aria-describedby={idpop10}
                  sx={{
                    cursor: "pointer",
                    fontSize: 42, // bigger size (default is 24)
                    color: "black", // darker
                    fontWeight: "bold",
                  }}
                ></ArrowDropDown>
                <Popover
                  id={idpop10}
                  open={openpop10}
                  anchorEl={anchorEl10}
                  onClose={handleClosepopOver10}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                    sx={{
                  zIndex: 1515,
                }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "0.5rem",
                      background: "#356f60",
                    }}
                  >
                    {newdentist == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={opendentist}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Ours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={opendentist}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              Use Ours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                    {newdentist == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={(e) => {
                            settype("dentist");
                            handleOpen();
                          }}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Yours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={(e) => {
                              settype("dentist");
                              handleOpen();
                            }}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              {" "}
                              Upload Yours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Popover>
              </Grid>
            </Grid>

            <Grid item xs={0.5}></Grid>
            <Grid item xs={8.5}>
              <Grid
                container
                alignItems="center"
                sx={{
                  display: "flex",
                  flexWrap: "nowrap", // keep checkbox & label in same row
                }}
              >
                <input
                  name="disclaimer"
                  size="small"
                  type="checkbox"
                  disabled={disable}
                  {...register("disclaimer")}
                  id="disclaimer"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    marginTop: "-10px",
                    transform: "scale(1.2)", // make bigger
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                  }}
                />

                <label
                  htmlFor="disclaimer"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    whiteSpace: "normal", // allow text wrap
                    wordBreak: "break-word", // break long words
                    flex: 1, // take remaining width
                  }}
                >
                  Financial agreement (recommended for your records only)
                </label>
              </Grid>
            </Grid>

            <Grid item xs={3} style={{ marginTop: "-5px" }}>
              <Grid style={{ marginLeft: "1rem" }}>
                <ArrowDropDown
                  variant="outlined"
                  onClick={handleClick7}
                  aria-describedby={idpop7}
                  sx={{
                    cursor: "pointer",
                    fontSize: 42, // bigger size (default is 24)
                    color: "black", // darker
                    fontWeight: "bold",
                  }}
                ></ArrowDropDown>
                <Popover
                  id={idpop7}
                  open={openpop7}
                  anchorEl={anchorEl7}
                  onClose={handleClosepopOver7}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                    sx={{
                  zIndex: 1515,
                }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "0.5rem",
                      background: "#356f60",
                    }}
                  >
                    {newdisclaimer == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={opendisclaimer}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Ours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={opendisclaimer}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              Use Ours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                    {newdisclaimer == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={(e) => {
                            settype("disclaimer");
                            handleOpen();
                          }}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Yours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={(e) => {
                              settype("disclaimer");
                              handleOpen();
                            }}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              {" "}
                              Upload Yours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Popover>
              </Grid>
            </Grid>

            <Grid item xs={0.5}></Grid>
            <Grid item xs={8.5}>
              <Grid
                container
                alignItems="center"
                sx={{
                  display: "flex",
                  flexWrap: "nowrap", // keep checkbox + labels in one row
                }}
              >
                <input
                  name="healthHistory"
                  size="small"
                  type="checkbox"
                  disabled={disable}
                  {...register("healthHistory")}
                  onChange={(e) => {
                    setValue("healthHistory", e.target.checked);
                    sethistory("healthHistory", e.target.checked);
                  }}
                  id="healthHistory"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    marginTop: "-10px",
                    transform: "scale(1.2)", // bigger checkbox
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                  }}
                />

                {/* Required star */}
                <label
                  htmlFor="healthHistory"
                  style={{
                    fontWeight: "bold",
                    color: "red",
                    fontSize: "15px",
                    marginRight: "3px",
                  }}
                >
                  *
                </label>

                {/* Main label text */}
                <label
                  htmlFor="healthHistory"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    whiteSpace: "normal", // allow wrapping on smaller screens
                    wordBreak: "break-word",
                    flex: 1, // take remaining width
                  }}
                >
                  Face-to-face referring provider notes before the Sleep test
                </label>
              </Grid>
            </Grid>

            <Grid item xs={3} style={{ marginTop: "-5px" }}>
              {/* {history == true ? (
                <Tooltip title="View">
                <Button
                  style={{
                    backgroundColor: disable ? 'gery' : '',
                    color: 'white',

                  }}
                  size='small'
                  disabled={disable == true ? true : false}
                  onClick={(e) => {
                    settype('healthHistory')
                    handleOpen()
                  }}>
                  <RemoveRedEyeIcon
                    fontSize="medium"
                    style={{ color: "#356F60", }}
                  ></RemoveRedEyeIcon>
                  View Yours
                </Button>
                </Tooltip>
              ) : (
                <>
                <Tooltip title="Add New">
                  <Button

                    style={{
                      backgroundColor: disable ? 'gery' : '#E87426',
                      color: 'white',

                    }}

                    size='small'
                    disabled={disable == true ? true : false}
                    onClick={(e) => {
                      settype('healthHistory')
                      handleOpen()
                    }}
                  >
                    <AddIcon
                      fontSize="medium"
                      style={{ color: "#356F60", paddingRight: "5px" }}
                    ></AddIcon>
                    Add Yours
                  </Button>
                  </Tooltip>
                </>
              )} */}
              <Grid style={{ marginLeft: "1rem" }}>
                <ArrowDropDown
                  variant="outlined"
                  onClick={handleClick3}
                  aria-describedby={idpop3}
                  sx={{
                    cursor: "pointer",
                    fontSize: 42, // bigger size (default is 24)
                    color: "black", // darker
                    fontWeight: "bold",
                  }}
                ></ArrowDropDown>
                <Popover
                  id={idpop3}
                  open={openpop3}
                  anchorEl={anchorEl3}
                  onClose={handleClosepopOver3}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                    sx={{
                  zIndex: 1515,
                }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "0.5rem",
                      background: "#356f60",
                    }}
                  >
                    {history == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={(e) => {
                            settype("healthHistory");
                            handleOpen();
                          }}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Yours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={(e) => {
                              settype("healthHistory");
                              handleOpen();
                            }}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              {" "}
                              Upload Yours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Popover>
              </Grid>
            </Grid>

            <Grid item xs={0.5}></Grid>
            <Grid item xs={9.5} style={{ marginTop: "-20px" }}>
              <Grid container columnSpacing={1}>
                <label
                  for="healthHistory"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    marginLeft: "50px",
                  }}
                >
                  {" "}
                  (Medicare and Medicare Advantage plans must be IN-Person)
                </label>
              </Grid>
            </Grid>


  <Grid item xs={2}></Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={8.5}>
              <Grid
                container
                alignItems="center"
                sx={{
                  display: "flex",
                  flexWrap: "nowrap", // keep items in one row
                }}
              >
                <input
                  name="sleepStudy"
                  size="small"
                  type="checkbox"
                  disabled={disable}
                  {...register("sleepStudy")}
                  onChange={(e) => {
                    setValue("sleepStudy", e.target.checked);
                  }}
                  id="sleepStudy"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    marginTop: "-10px",
                    transform: "scale(1.2)", // bigger checkbox
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                  }}
                />
                <label
                  htmlFor="sleepStudy"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    whiteSpace: "normal", // allow wrapping
                    wordBreak: "break-word",
                    flex: 1, // take up remaining space
                  }}
                >
                  The follow up visit AFTER the Sleep Study occured (sometimes with the sleep study results) </label>
              </Grid>
            </Grid>
 <Grid item xs={3} style={{ marginTop: "-5px" }}>
              <Grid style={{ marginLeft: "1rem" }}>
                <ArrowDropDown
                  variant="outlined"
                  onClick={handleClickSleepStudy}
                  aria-describedby={idpopSleepStudy}
                  sx={{
                    cursor: "pointer",
                    fontSize: 42, // bigger size (default is 24)
                    color: "black", // darker
                    fontWeight: "bold",
                  }}
                ></ArrowDropDown>
                <Popover
                  id={idpopSleepStudy}
                  open={openSleepStudy}
                  anchorEl={anchorSleepStudy}
                  onClose={handleCloseSleepStudy}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                    sx={{
                  zIndex: 1515,
                }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "0.5rem",
                      background: "#356f60",
                    }}
                  >
                    {watch("sleepStudy") == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={(e) => {
                            settype("sleepStudy");
                            handleOpen();
                          }}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Yours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={(e) => {
                              settype("sleepStudy");
                              handleOpen();
                            }}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              {" "}
                              Upload Yours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Popover>
              </Grid>
            </Grid>



            <Grid item xs={0.5}></Grid>
            <Grid item xs={8.5}>
              <Grid
                container
                alignItems="center"
                sx={{
                  display: "flex",
                  flexWrap: "nowrap", // keep items in one row
                }}
              >
                <input
                  name="sleepTest"
                  size="small"
                  type="checkbox"
                  disabled={disable}
                  {...register("sleepTest")}
                  onChange={(e) => {
                    setValue("sleepTest", e.target.checked);
                    setsleeptest("sleepTest", e.target.checked);
                  }}
                  id="sleepTest"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    marginTop: "-10px",
                    transform: "scale(1.2)", // bigger checkbox
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                  }}
                />

                {/* Required star */}
                <label
                  htmlFor="sleepTest"
                  style={{
                    fontWeight: "bold",
                    color: "red",
                    fontSize: "15px",
                    marginRight: "3px",
                  }}
                >
                  *
                </label>

                {/* Main label text */}
                <label
                  htmlFor="sleepTest"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    whiteSpace: "normal", // allow wrapping
                    wordBreak: "break-word",
                    flex: 1, // take up remaining space
                  }}
                >
                  The baseline sleep test needs to be signed
                </label>
              </Grid>
            </Grid>

            <Grid item xs={3} style={{ marginTop: "-5px" }}>
              <Grid style={{ marginLeft: "1rem" }}>
                <ArrowDropDown
                  variant="outlined"
                  onClick={handleClick5}
                  aria-describedby={idpop5}
                  sx={{
                    cursor: "pointer",
                    fontSize: 42, // bigger size (default is 24)
                    color: "black", // darker
                    fontWeight: "bold",
                  }}
                ></ArrowDropDown>
                <Popover
                  id={idpop5}
                  open={openpop5}
                  anchorEl={anchorEl5}
                  onClose={handleClosepopOver5}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                    sx={{
                  zIndex: 1515,
                }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "0.5rem",
                      background: "#356f60",
                    }}
                  >
                    {sleeptest == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={(e) => {
                            settype("sleepTest");
                            handleOpen();
                          }}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Yours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={(e) => {
                              settype("sleepTest");
                              handleOpen();
                            }}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              {" "}
                              Upload Yours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Popover>
              </Grid>
            </Grid>

            <Grid item xs={0.5}></Grid>
            <Grid item xs={10.5} sx={{ mt: -2 }}>
              <Grid
                container
                alignItems="flex-start"
                sx={{
                  display: "flex",
                  flexWrap: "nowrap",
                }}
              >
                <label
                  htmlFor="sleepTest"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    marginLeft: "42px",
                    whiteSpace: "normal", // allow wrapping
                    wordBreak: "break-word",
                    flex: 1, // take full width
                  }}
                >
                  ● AHI must be between 5-29 (under 5 carriers will not approve
                  as this is not considered sleep apnea)
                  {/* ●AHI = 30+ Patient Must have tried and failed CPAP */}
                </label>
              </Grid>
            </Grid>

            <Grid item xs={1}></Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={8.5}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "nowrap", // hamesha ek line me rakhega
                }}
              >
                {/* Checkbox */}
                <input
                  name="lomn"
                  size="small"
                  type="checkbox"
                  disabled={disable}
                  {...register("lomn")}
                  onChange={(e) => {
                    setValue("lomn", e.target.checked);
                    setLomn("lomn", e.target.checked);
                  }}
                  id="LOMN"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    transform: "scale(1.2)", // bada checkbox
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                  }}
                />

                {/* Required star */}
                <label
                  htmlFor="LOMN"
                  style={{
                    fontWeight: "bold",
                    color: "red",
                    fontSize: "15px",
                    marginRight: "3px",
                  }}
                >
                  *
                </label>

                {/* Label text */}
                <label
                  htmlFor="LOMN"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    whiteSpace: "normal", // wrap allow karega
                    wordBreak: "break-word",
                    flex: 1, // text jitni jagah chahiye le lega
                  }}
                >
                  LOMN (Letter of Medical Necessity)
                </label>
              </Box>
            </Grid>

            <Grid item xs={3} style={{ marginTop: "-5px" }}>
              <Grid style={{ marginLeft: "1rem" }}>
                <ArrowDropDown
                  variant="outlined"
                  onClick={handleClick1}
                  aria-describedby={idpop1}
                  sx={{
                    cursor: "pointer",
                    fontSize: 42, // bigger size (default is 24)
                    color: "black", // darker
                    fontWeight: "bold",
                  }}
                ></ArrowDropDown>
                <Popover
                  id={idpop1}
                  open={openpop1}
                  anchorEl={anchorEl1}
                  onClose={handleClosepopOver1}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                    sx={{
                  zIndex: 1515,
                }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "0.5rem",
                      background: "#356f60",
                    }}
                  >
                    {/* {lomn == true ? (
                        <Tooltip title="View">
                          <Button
                            style={{
                              backgroundColor: disable ? 'gery' : '',
                              color: 'white',


                            }}
                            size='small'
                            disabled={disable == true ? true : false}
                            onClick={handleOpen2}>
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff", }}
                            >View Ours</Typography>

                          </Button>
                        </Tooltip>
                      ) : (
                        <>
                          <Tooltip title="Add New">
                            <Button
                              style={{
                                backgroundColor: disable ? 'gery' : '',
                                color: 'white',

                              }}
                              size='small'
                              disabled={disable == true ? true : false}
                              onClick={handleOpen2}>
                              <Typography
                                fontSize="medium"
                                style={{ color: "#fff",}}
                              >Upload Ours</Typography>

                            </Button>
                          </Tooltip>
                        </>
                      )} */}
                    {lomn == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={(e) => {
                            settype("lomn");
                            handleOpen();
                          }}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Yours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={(e) => {
                              settype("lomn");
                              handleOpen();
                            }}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              {" "}
                              Upload Yours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Popover>
              </Grid>
            </Grid>

            <Grid item xs={0.5}></Grid>
            <Grid item xs={10.5} style={{ marginTop: "-20px" }}>
              <Grid container columnSpacing={1}>
                <label
                  for="LOMN"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    marginLeft: "50px",
                  }}
                >
                  {" "}
                  ● This may come from the sleep test facility Dr. or the
                  patient's Primary care Dr.
                </label>
              </Grid>
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={8.5}>
              <Grid
                container
                columnSpacing={1}
                style={{
                  display: "flex",
                  alignItems: "center", // checkbox aur text ko vertically center karega
                  flexWrap: "wrap", // chhoti screen pe text wrap ho jaye
                }}
              >
                <input
                  name="progressNotes"
                  size="small"
                  type="checkbox"
                  disabled={disable === true}
                  {...register("progressNotes")}
                  id="progressNotes"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    transform: "scale(1.2)", // checkbox bada
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                    marginLeft: "17px",
                  }}
                />

                <label
                  htmlFor="progressNotes"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    fontSize: "0.95rem",
                    whiteSpace: "nowrap",
                    marginLeft: "10px", // same line me rakhe jab space ho
                  }}
                >
                  Progress Notes
                </label>
              </Grid>
            </Grid>

            <Grid item xs={3} style={{ marginTop: "-5px" }}>
              <Grid style={{ marginLeft: "1rem" }}>
                <ArrowDropDown
                  variant="outlined"
                  onClick={handleClick6}
                  aria-describedby={idpop6}
                  sx={{
                    cursor: "pointer",
                    fontSize: 42, // bigger size (default is 24)
                    color: "black", // darker
                    fontWeight: "bold",
                  }}
                ></ArrowDropDown>
                <Popover
                  id={idpop6}
                  open={openpop6}
                  anchorEl={anchorEl6}
                  onClose={handleClosepopOver6}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                    sx={{
                  zIndex: 1515,
                }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      padding: "0.5rem",
                      background: "#356f60",
                    }}
                  >
                    {processnote == true ? (
                      <Tooltip title="View">
                        <Button
                          style={{
                            backgroundColor: disable ? "gery" : "",
                            color: "white",
                          }}
                          size="small"
                          disabled={disable == true ? true : false}
                          onClick={(e) => {
                            settype("progressNotes");
                            handleOpen();
                          }}
                        >
                          <Typography
                            fontSize="medium"
                            style={{ color: "#fff" }}
                          >
                            View Yours
                          </Typography>
                        </Button>
                      </Tooltip>
                    ) : (
                      <>
                        <Tooltip title="Add New">
                          <Button
                            style={{
                              backgroundColor: disable ? "gery" : "",
                              color: "white",
                            }}
                            size="small"
                            disabled={disable == true ? true : false}
                            onClick={(e) => {
                              settype("progressNotes");
                              handleOpen();
                            }}
                          >
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff" }}
                            >
                              {" "}
                              Upload Yours
                            </Typography>
                          </Button>
                        </Tooltip>
                      </>
                    )}
                  </div>
                </Popover>
              </Grid>
            </Grid>

            <Grid item xs={0.5}></Grid>
            <Grid item xs={10.5} style={{ marginTop: "-20px" }}>
              <Grid container columnSpacing={1}>
                <label
                  for="progressNotes"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    marginLeft: "50px",
                  }}
                >
                  {" "}
                  ● Initial consult/ SOAP note with the patient.
                </label>
              </Grid>
            </Grid>
            <Grid item xs={1}></Grid>

            {/* {questionnaire == true && history == true && lomn == true ? (
         
            ) : (<></>)} */}

            {/* <Grid item xs={0.5}></Grid>

            <Grid item xs={7.5}>
              <Grid container columnSpacing={1}>
                <input
                  name="approved"
                  size="small"
                  disabled={usertype == 'Front Office' || disable == true ? true : false}
                  // disabled={disable == true?true:false }
                  type="checkbox"
                  {...register("approved")}
                  id="approved"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                  }}
                />

                <Typography style={{ fontWeight: "bold", color: "black" }}>
                  Approved
                </Typography>
              </Grid>

            </Grid>
            <Grid item xs={3} style={{ marginTop: '-5px' }}>
             
               
<Grid style={{ marginLeft: '1rem' }}>
                  <ArrowDropDown
                    variant="outlined"
                    onClick={handleClick4}
                    aria-describedby={idpop4}
                    style={{ cursor: 'pointer' }}
                  >
                  </ArrowDropDown>
                  <Popover
                    id={idpop4}
                    open={openpop4}
                    anchorEl={anchorEl4}
                    onClose={handleClosepopOver4}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', padding: '0.5rem', background: '#356f60',}}>
                      {approve == true ? (
                        <Tooltip title="View">
                          <Button
                            style={{
                              backgroundColor: disable ? 'gery' : '',
                              color: 'white',


                            }}
                            size='small'
                            disabled={disable == true ? true : false}
                            onClick={handleOpen4}>
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff", }}
                            >View Ours</Typography>

                          </Button>
                        </Tooltip>
                      ) : (
                        <>
                          <Tooltip title="Add New">
                            <Button
                              style={{
                                backgroundColor: disable ? 'gery' : '',
                                color: 'white',

                              }}
                              size='small'
                              disabled={disable == true ? true : false}
                              onClick={handleOpen4}>
                              <Typography
                                fontSize="medium"
                                style={{ color: "#fff",}}
                              >Upload Ours</Typography>

                            </Button>
                          </Tooltip>
                        </>
                      )}
                       
                    </div>
                  </Popover>
                </Grid>

            </Grid>
            <Grid item xs={1}></Grid> */}
            <Grid item xs={0.5}></Grid>
            <Grid item xs={8.5}>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  fontWeight: "bold",
                  fontSize: "0.95rem",
                  width: "100%",
                }}
              >
                {/* Checkbox */}
                <input
                  name="additionalInfo"
                  size="small"
                  type="checkbox"
                  disabled={disable}
                  {...register("additionalInfo")}
                  id="additionalInfo"
                  style={{
                    transform: "scale(1.2)",
                    cursor: disable ? "not-allowed" : "pointer",
                    marginRight: "10px",
                    marginLeft: "10px",
                  }}
                />

                {/* Main text */}
                <span
                  style={{
                    color: "black",
                    flex: 1,
                    whiteSpace: "normal", // allow text to wrap naturally
                    overflowWrap: "break-word", // break only if too long
                  }}
                >
                  Any additional information you have or think would be helpful
                  to obtain authorization?
                </span>

                {/* Right aligned link + arrow */}
                <span
                  style={{
                    color: "#0d6efd",
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "auto",
                    whiteSpace: "nowrap", // keep this in one line
                  }}
                >
                  Bulk File Drop here (Except LOMN)
                  <span style={{ marginLeft: "6px", fontSize: "1.2rem" }}>
                    ➜
                  </span>
                </span>
              </Box>
            </Grid>

            <Grid item xs={3} style={{ marginTop: "-5px" }}>
              <Grid>
                {/* <ArrowDropDown
                  variant="outlined"
                  onClick={handleClick9}
                  aria-describedby={idpop9}
                  sx={{
                    cursor: "pointer",
                    fontSize: 42, // bigger size (default is 24)
                    color: "black", // darker
                    fontWeight: "bold",
                  }}
                ></ArrowDropDown> */}
                {/* <Popover
                  id={idpop9}
                  open={openpop9}
                  anchorEl={anchorEl9}
                  onClose={handleClosepopOver9}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                  }}
                > */}

                {additionalinfo == true ? (
                  <Tooltip title="View">
                    <Button
                      style={{
                        backgroundColor: disable ? "gery" : "",
                        color: "white",
                        backgroundColor: "#00796B",
                      }}
                      size="small"
                      disabled={disable == true ? true : false}
                      onClick={(e) => {
                        settype("additionalInfo");
                        handleOpen();
                      }}
                    >
                      <Typography fontSize="medium" style={{ color: "#fff" }}>
                        View Yours
                      </Typography>
                    </Button>
                  </Tooltip>
                ) : (
                  <>
                    <Tooltip title="Add New">
                      <Button
                        style={{
                          backgroundColor: disable ? "grey" : "green",
                          color: "white",
                          fontSize: "0.7rem",
                          lineHeight: "1rem",
                          height: "40px",
                          fontSize: "15px", 
                        textAlign: "center", 
                        padding: "6px 10px", 
                        lineHeight: "1.2", 
                         border: "1px solid #377562", 
                      padding: "15px 30px",
                    borderRadius: "10px",
                    boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                        }}
                        size="small"
                        disabled={disable}
                        onClick={(e) => {
                          settype("additionalInfo");
                          handleOpen();
                        }}
                      >
                        Upload Yours
                      </Button>
                    </Tooltip>
                  </>
                )}

                {/* </Popover> */}
              </Grid>
            </Grid>

            {/* <Grid item xs={0.5}></Grid>
            <Grid item xs={9.5} style={{ marginTop: '-20px' }}>

              <Grid container columnSpacing={1}>
                <label  for="additionalInfo" style={{ fontWeight: "bold", color: "black",marginLeft:'8px' }}> authorization? </label>
              
              </Grid>

            </Grid>
            <Grid item xs={2}></Grid> */}
            <Grid item xs={0.5}></Grid>
            <Grid item xs={8}>
              <Grid container columnSpacing={1}>
                <input
                  name="authRequest"
                  size="small"
                  type="checkbox"
                  disabled
                  {...register("authRequest")}
                  id="authRequest"
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    marginTop: "-10px",
                    transform: "scale(1.2)", // <<< This makes it bigger
                    transformOrigin: "center",
                    cursor: disable ? "not-allowed" : "pointer",
                    marginLeft: "18px",
                  }}
                />
                {/* && getValues('questionnaire') == 'on'&& getValues('healthHistory') == 'on' &&  getValues('sleepTest') == 'on' &&   getValues('lomn')== 'on'  */}
                {getValues("idCard") == true &&
                getValues("questionnaire") == true &&
                getValues("healthHistory") == true &&
                getValues("sleepTest") == true &&
                getValues("lomn") == true ? (
                  <>
                    <label
                      for="authRequest"
                      style={{
                        fontWeight: "bold",
                        color: "green",
                        marginLeft: "10px",
                      }}
                    >
                      {" "}
                      VOB/ Prior-auth Request form{" "}
                    </label>
                    {/* <Typography style={{ fontWeight: "bold", color: "green" }}>
                  VOB/ Prior-auth Request form
                </Typography> */}
                  </>
                ) : (
                  <>
                    <label
                      for="authRequest"
                      style={{ fontWeight: "bold", color: "red" }}
                    >
                      {" "}
                      VOB/ Prior-auth Request form{" "}
                    </label>

                    {/* <Typography style={{ fontWeight: "bold", color: "red" }}>
                  VOB/ Prior-auth Request form
                </Typography> */}
                  </>
                )}
              </Grid>
            </Grid>
            <Grid item xs={3.5} style={{ marginTop: "-5px" }}>
              {authRequest == true ? (
                <Tooltip title="View">
                  <Button
                    style={{
                      // && questionnaire && history && sleeptest && lomn
                      // backgroundColor: idcard && questionnaire  ? 'green' : 'red',
                        border: "1px solid #377562", // matches theme  
              // padding: "15px 30px",
                    borderRadius: "10px",
                    boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                      backgroundColor:
                        getValues("idCard") == true &&
                        getValues("questionnaire") == true &&
                        getValues("healthHistory") == true &&
                        getValues("sleepTest") == true &&
                        getValues("lomn") == true
                          ? "green"
                          : "red",
                        color: "white",
                          fontSize: "11px", // smaller font for better appearance
                        textAlign: "center", // justify text
                        padding: "6px 10px", // tighter padding for smaller button
                        lineHeight: "1.2", // better line spacing
                    }}
                    size="small"
                    // && questionnaire == true && history == true && sleeptest ==true  && lomn ==true
                    disabled={
                      getValues("idCard") == true &&
                      getValues("questionnaire") == true &&
                      getValues("healthHistory") == true &&
                      getValues("sleepTest") == true &&
                      getValues("lomn") == true
                        ? false
                        : true
                    }
                    onClick={handleOpen3}
                  >
                  Submit Prior-Auth/Vob to Billing team for Review
                  </Button>
                </Tooltip>
              ) : (
                <>
                  <Tooltip title="Add New">
                    <Button
                      // && questionnaire && history && sleeptest && lomn
                      style={{
                        // display: "inline-block",
              //  backgroundColor: "#E9F5F1", // light mint contrast
               border: "1px solid #377562", // matches theme  
              // padding: "15px 30px",
              borderRadius: "10px",
              boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
              // fontWeight: "bold",
              // color: "#333",
                        backgroundColor:
                          getValues("idCard") == true &&
                          getValues("questionnaire") == true &&
                          getValues("healthHistory") == true &&
                          getValues("sleepTest") == true &&
                          getValues("lomn") == true
                            ? "green"
                            : "red",
                        color: "white",
                                  fontSize: "11px", // smaller font for better appearance
                        textAlign: "center", // justify text
                        padding: "6px 10px", // tighter padding for smaller button
                        lineHeight: "1.2", // better line spacing
                      }}
                      size="small"
                      // && questionnaire == true && history == true && sleeptest ==true && lomn ==true
                      disabled={
                        getValues("idCard") == true &&
                        getValues("questionnaire") == true &&
                        getValues("healthHistory") == true &&
                        getValues("sleepTest") == true &&
                        getValues("lomn") == true
                          ? false
                          : true
                      }
                      onClick={handleOpen3}
                    >
         
           Submit Prior-Auth/Vob to Billing team for Review
                    </Button>
                  </Tooltip>
                </>
              )}
              {/* <Grid style={{ marginLeft: '1rem' }}>
                  <ArrowDropDown
                    variant="outlined"
                    onClick={handleClick2}
                    aria-describedby={idpop2}
                    style={{ cursor: 'pointer' }}
                  >
                  </ArrowDropDown>
                  <Popover
                    id={idpop2}
                    open={openpop2}
                    anchorEl={anchorEl2}
                    onClose={handleClosepopOver2}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'left',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', padding: '0.5rem', background: '#356f60',}}>
                      {authRequest == true ? (
                        <Tooltip title="View">
                          <Button
                            style={{
                              backgroundColor: disable ? 'gery' : '',
                              color: 'white',


                            }}
                            size='small'
                            disabled={disable == true ? true : false}
                            onClick={handleOpen3}>
                            <Typography
                              fontSize="medium"
                              style={{ color: "#fff", }}
                            >View Ours</Typography>

                          </Button>
                        </Tooltip>
                      ) : (
                        <>
                          <Tooltip title="Add New">
                            <Button
                              style={{
                                backgroundColor: disable ? 'gery' : '',
                                color: 'white',

                              }}
                              size='small'
                              disabled={disable == true ? true : false}
                              onClick={handleOpen3}>
                              <Typography
                                fontSize="medium"
                                style={{ color: "#fff",}}
                              >Upload Ours</Typography>

                            </Button>
                          </Tooltip>
                        </>
                      )}
                        {authRequest == true ? (
                          <Tooltip title="View">
                            <Button
                              style={{
                                backgroundColor: disable ? 'gery' : '',
                                color: 'white',

                              }}
                              size='small'
                              disabled={disable == true ? true : false}
                              onClick={(e) => {
                                settype('authRequest')
                                handleOpen()
                              }}>
                             
                              <Typography
                                fontSize="medium"
                                style={{ color: "#fff", }}
                              >View Yours</Typography>

                            </Button>
                          </Tooltip>
                        ) : (
                          <>
                            <Tooltip title="Add New">
                              <Button

                                style={{
                                  backgroundColor: disable ? 'gery' : '',
                                  color: 'white',

                                }}

                                size='small'
                                disabled={disable == true ? true : false}
                                onClick={(e) => {
                                  settype('authRequest')
                                  handleOpen()
                                }}
                              >
                                <Typography
                                  fontSize="medium"
                                  style={{ color: "#fff", }}
                                > Upload Yours
                                </Typography>
                              </Button>
                            </Tooltip>
                          </>
                        )}
                    </div>
                  </Popover>
                </Grid> */}
            </Grid>

            <Grid item xs={0.5}>
              {" "}
              <Typography
                style={{ fontWeight: "bold", color: "green" }}
              ></Typography>
            </Grid>
            <Grid item xs={9.5} style={{ marginTop: "-20px" }}>
              <Grid container columnSpacing={1}>
                <label
                  for="authRequest"
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    marginLeft: "50px",
                  }}
                >
                  {" "}
                  ● Name, Date of Birth & address MUST be correct or the carrier
                  may reject any submitted requests.{" "}
                </label>
              </Grid>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={12} lg={12} sm={12} textAlign="right">

              <Button
                className="Button"
                onClick={handleSubmit(onSubmit)}
                disabled={FirstClick || disable}
                variant="gradient"
                style={{
                  // marginBottom: "50px",
                  // marginRight: "20px",
                  float: "right",
                     width: "100px",
                  height: "35px",
                  backgroundColor:
                    FirstClick || disable || disable ? "#ccc" : "#E87426",
                  color: "white",
                  fontSize: "14px",
                  cursor:
                    FirstClick || disable || disable
                      ? "not-allowed"
                      : "pointer",
                  opacity: FirstClick || disable || disable ? 0.6 : 1,
                }}
              >
                {disable ? (
                  <>
                    <CircularProgress
                      size={16}
                      style={{ color: "white", marginRight: "5px" }}
                    />
                    Saving...
                  </>
                ) : (
                  <>
                    <SaveOutlinedIcon
                      fontSize="medium"
                      style={{ color: "white", paddingRight: "5px" }}
                    />
                    Save
                  </>
                )}
              </Button>
              </Grid>
  
              {/* <Button
              className="Button"
              onClick={handleOpen4}
              disabled={disable == true ? true : false }
            
              variant="gradient"
              style={{
           
                marginBottom: "50px",
                marginRight: "20px",
                float: "right",
                width: "100px",
                height: "35px",
                color: "white",
                fontSize: "14px",
              }}
            >
              Approve
            </Button> 
            </Grid>*/}
            {/* <Grid item xs={12} textAlign="center" sx={{ mt: 3 }}>
          <div
            style={{
              display: "inline-block",
               backgroundColor: "#E9F5F1", // light mint contrast
               border: "1px solid #377562", // matches theme  
              padding: "15px 30px",
              borderRadius: "10px",
              boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
              fontWeight: "bold",
              color: "#333",
            }}
          >
           Submitt Prior-Auth/Vob to Billing team for Reviews
          </div>
        </Grid> */}

    


          </Grid>
        </Grid>

        {/* <Grid container>
          <Grid item xs={12} lg={12} sm={12}>
            <Button
              className="Button"
              onClick={handleSubmit(onSubmit)}
              disabled={disable == true ? true : false}
              variant="gradient"
              style={{
                // marginTop: "10px",
                marginBottom: "20px",
                marginRight: "20px",
                float: "right",
                // marginLeft: "850px",
                width: "80px",
                height: "35px",
                // backgroundColor: "#E87426",
                // backgroundColor: "linear-gradient(180deg, rgb(209, 52, 80) 0%, rgb(209, 52, 80) 0%, rgb(240, 130, 49) 100%",
                color: "white",
                fontSize: "14px",
              }}
            >

              <SaveOutlinedIcon
                fontSize="medium"
                style={{ color: "#356F60", paddingRight: "5px" }}
              ></SaveOutlinedIcon>
              Save
            </Button>
          </Grid>

        </Grid> */}
      </Container>
    </>
  );
};

export default AuthorizationRegistration;
